export { SkillCustomerFacing as default } from './SkillCustomerFacing';
